module.exports = __webpack_public_path__ + "static/media/OrganizationWork.f8dd0858.jpg";